
import Consts from "Interfaces/Consts";

const ContactUsSubmitButton: React.FC = () => {

    return <div className="form-row text-center btnRow">

        <div className="form-group col-md-12 mzFormGroup btn-contianer-horizontal">

            <input type="submit" className="btn mst-btn btn-primary px-2 px-md-auto mst-send-btn btn-horizontal"
                value={Consts.send} />

            <div className="btn mst-btn btn-primary px-2 px-md-auto pt-2 mst-loader-btn d-none" >

                <img
                    className="loader"
                    src="/Images/Components/Loader.png"
                    alt="loader" /> &nbsp; {Consts.wait}

            </div>
        </div>

    </div>
}

export default ContactUsSubmitButton;